export default "__VITE_ASSET__DDGdvb9B__"